import { createContext, useContext, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * AppShell 고정 헤더 자리(A1)에 페이지가 자기 헤더를 그리게 하는 연결부.
 * AppShell은 셸 단위로 header 하나만 받지만, 제목·건수·액션·뷰 탭은 페이지마다 달라
 * 페이지가 <ShellHeader>로 헤더 내용을 셸의 헤더 자리에 포털로 넣는다.
 */
const ShellHeaderSlotContext = createContext<HTMLElement | null>(null);

export function useShellHeaderSlot() {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return { slot, slotRef: setSlot };
}

export function ShellHeaderSlotProvider({
  slot,
  children,
}: {
  slot: HTMLElement | null;
  children: ReactNode;
}) {
  return <ShellHeaderSlotContext.Provider value={slot}>{children}</ShellHeaderSlotContext.Provider>;
}

/** 페이지 헤더(PageHeader·DetailPageHeader·헤더 아래 탭·전체 폭 배너)를 셸 헤더 자리에 렌더한다. */
export function ShellHeader({ children }: { children: ReactNode }) {
  const slot = useContext(ShellHeaderSlotContext);
  return slot ? createPortal(children, slot) : null;
}
